// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { notifyDanger } from '@gandi/notifications';
import { selectCurrentId } from '@gandi/redux-sharing';
import { withTranslator } from '@gandi/translate';

import { actions } from 'gandi.react-form';

import { withRouter } from 'src/helpers/withRouter';

import type { FullState, MapDispatchToProps } from '../../../types';
import CustomerForm from '../components/Form/CustomerForm';

import { createCustomer, selectIsCreatingCustomer } from '../modules/customers';

import Presenter from './components/Presenter';

import type { StateProps, DispatchProps } from './components/Presenter';

const mapStateToProps = (state: FullState): StateProps => ({
  currentOrganizationId: selectCurrentId(state),
  isCreatingCustomer: selectIsCreatingCustomer(state),
});

const mapActionsToProps: MapDispatchToProps<DispatchProps> = {
  createCustomer,
  notifyDanger,
  destroyForm: actions.destroy.bind(null, CustomerForm.FORM_ID),
};

const connector = connect<any, any, StateProps, DispatchProps, FullState, any>(
  mapStateToProps,
  mapActionsToProps,
);

export default (compose(
  connector,
  withRouter,
  withTranslator({ propsNamespace: 'translator' }),
)(Presenter): React.ComponentType<{}>);
